import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { Tenant } from './tenant.interface';

export class TenantService {
   async getTenants(query?: LocationQuery): Promise<ApiResource<Array<Tenant>>> {
      const response = await http.get<ApiResource<Array<Tenant>>>(`/tenants`, { params: { ...query } });
      return response.data;
   }

   async getTenant(tenantId: number) {
      const response = await http.get<Tenant>(`/tenants/${tenantId}`);
      return response.data;
   }

   async postTenant(tenant: Tenant) {
      const response = await http.post<Tenant>(`/tenants`, tenant);
      return response.data;
   }

   async putTenant(tenantId: number, tenant: Tenant, query?: LocationQuery) {
      const response = await http.put<Tenant>(`/tenants/${tenantId}`, tenant, { params: { ...query } });
      return response.data;
   }

   async deleteTenant(tenantId: number) {
      const response = await http.delete<void>(`/tenants/${tenantId}`);
      return response.data;
   }
}
